import { Box, Tooltip, Switch, useMediaQuery } from "@mui/material";
import React, { useRef, useState } from "react";
import {
  PlanoButton,
  PlanoLoaderModal,
  PlanoTypography,
} from "../../../Common";
import "./PlanogramImageCard2.css";
import shelfImage from "../../../Assets/shelf.png";
import PlanoSplitButton from "../../../Common/PlanoSplitButton";
import { FaPrint } from "react-icons/fa6";

const PlanogramImageCard2 = ({
  showImages,
  source = [],
  bayNumber,
  imageData,
}) => {
  const ref = useRef(null);
  const [heightValue, setHeightValue] = useState("70vh");
  const [loader, setLoader] = useState(false);
  const [typeOfPrint, setTypeOfPrint] = useState("Image Print");
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Adjust breakpoint as needed

  const handleTypeOfPrint = (e) => {
    if (e.target.checked) {
      setTypeOfPrint("Text Print");
    } else {
      setTypeOfPrint("Image Print");
    }
  };
  const handlePrint = (value) => {
    setTypeOfPrint(value);
    setHeightValue("100%");
    setLoader(true);
    setTimeout(() => {
      window.print();
      setHeightValue("70vh");
      setLoader(false);
    }, 2000);
  };

  return (
    <Box
      width={isSmallScreen ? "auto" : "70%"}
      mt={isSmallScreen && 2}
      bgcolor={"white"}
      p={2}
      borderRadius={"12px"}
      height={"83vh"}
      sx={{
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
      }}
    >
      <Box display={"flex"} justifyContent={"right"} gap={2}>
        {/* <PlanoSplitButton
          options={["Image Print", "Text Print"]}
          setSelectedValue={setTypeOfPrint}
          handlePrint={handlePrint}
        /> */}
        <PlanoButton
          extraCss={{
            height: "2rem",
            backgroundColor:
              typeOfPrint === "Text Print"
                ? "lightgrey !important"
                : "#f04e23 !important",
          }}
          mainfunction={() => handlePrint("Image Print")}
          startIcon={
            <FaPrint
              style={{
                fontSize: "24px",
                color: "white",
              }}
            />
          }
        >
          Image Print
        </PlanoButton>
        <PlanoButton
          extraCss={{
            height: "2rem",
            backgroundColor:
              typeOfPrint === "Image Print"
                ? "lightgrey !important"
                : "#f04e23 !important",
          }}
          mainfunction={() => handlePrint("Text Print")}
          startIcon={
            <FaPrint
              style={{
                fontSize: "24px",
                color: "white",
              }}
            />
          }
        >
          Text Print
        </PlanoButton>
      </Box>

      <Box className="printable-area">
        <PlanoTypography
          css={{
            textAlign: "center",
            fontSize: "2rem",
          }}
        >
          {bayNumber}
        </PlanoTypography>

        <Box
          height={heightValue}
          overflow={heightValue === "100%" ? "" : "scroll"}
          ref={ref}
        >
          {source.length > 0 && (
            <div
              style={{
                margin: "auto",
                marginTop: "8px",
              }}
            >
              {source?.map((shelf) => {
                const maxWidth = [];
                source.map((shelf) => {
                  maxWidth.push(shelf.shelf_width);
                });
                let max = Math.max(...maxWidth);
                return (
                  <div
                    key={shelf.shelf_number}
                    style={{
                      marginBottom: 8,
                      width: "100%",
                      backgroundImage: `url(${shelfImage})`,
                      backgroundColor: "white",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom",
                      backgroundSize: "100%",
                      minHeight: shelf.shelf_height * 3 + 10,
                    }}
                  >
                    <p
                      style={{
                        marginTop: "1rem",
                        textAlign: "center",
                      }}
                    >
                      Shelf Number : {shelf.shelf_number}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "end",
                      }}
                    >
                      {shelf.items.map((item) => {
                        const widthPercentage =
                          (item.width / shelf.shelf_width) * 100;
                        return (
                          <div
                            key={item.item}
                            style={{
                              marginRight: "2px",
                              borderRadius: "5px",
                              width: "100%",
                              position: "relative",
                            }}
                          >
                            <Tooltip
                              title={item.item_desc}
                              placement="bottom-start"
                            >
                              {typeOfPrint === "Image Print" ? (
                                <img
                                  loading="lazy"
                                  src={item.image_url}
                                  alt={item.item_desc}
                                  style={{
                                    objectFit: "fill",
                                    backgroundColor: "white",
                                    width: "100%",
                                    maxHeight: shelf.shelf_height * 5,
                                    marginBottom: "10px",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    objectFit: "fill",
                                    backgroundColor: "white",
                                    maxHeight: shelf.shelf_height * 5,
                                    marginBottom: "10px",
                                    border: "1px solid",
                                    textAlign: "center",
                                    fontSize: "x-small",
                                    width: "100%",
                                  }}
                                >
                                  {item.item_desc.slice(0, 30)}
                                </div>
                              )}

                              {item.image_type === "default_image" &&
                                typeOfPrint === "Image Print" && (
                                  <div className="centered">
                                    {item.item_desc.slice(0, 25)}....
                                  </div>
                                )}
                            </Tooltip>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Box>
      </Box>

      <PlanoLoaderModal
        open={loader}
        setOpen={setLoader}
        text="Image Printing in Progress"
      />
    </Box>
  );
};

export default PlanogramImageCard2;
